const crypto = require('crypto')
const Decimal = require('decimal.js')

export const getDicType = (name) => {
  let arr = name.split('.')
  let hz = arr[arr.length - 1]
  let imgArr = ['png', 'jpg', 'gif', 'jpeg', 'JPG', 'webp', 'jfif']
  let videoArr = ['wmv', 'mkv', 'mp4', 'mov', 'avi']
  let audioArr = ['mp3', 'mpeg']
  let threeModel = ['obj']
  if (imgArr.indexOf(hz) !== -1) {
    return 'img'
  } else if (videoArr.indexOf(hz) !== -1) {
    return 'video'
  } else if (audioArr.indexOf(hz) !== -1) {
    return 'audio'
  } else if (threeModel.indexOf(hz) !== -1) {
    return '3d'
  } else {
    return ''
  }
}
function add0(m) { return m < 10 ? '0' + m : m }
// 年月日时分秒
export const timeChange = (timestamp) => {
  if (timestamp) {
    var time = new Date(timestamp)
    var y = time.getFullYear()
    var m = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var mm = time.getMinutes()
    var s = time.getSeconds()
    return y + '/' + add0(m) + '/' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
  } else {
    return ''
  }
}
// 年月日转换
export const timeChangeYMD = (timestamp) => {
  if (timestamp) {
    var time = new Date(timestamp)
    var y = time.getFullYear()
    var m = time.getMonth() + 1
    var d = time.getDate()

    return y + '/' + add0(m) + '/' + add0(d)
  } else {
    return ''
  }
}
// oss压缩参数
export const ossParameters = () => {
  return '?x-oss-process=image/resize,h_600/quality,Q_50'
}
export const ossParametersBig = () => {
  return '?x-oss-process=image/resize,h_1000/quality,Q_50'
}
export const ossParameters1 = () => {
  return '?x-oss-process=image/resize,h_100/quality,Q_50'
}
// 加密
export const encode = (str) => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1)
    }))
}
// 解密
export const decode = (str) => {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

// header处理相关

export const randomString = (len, charSet) => {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let randomString = ''
  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length)
    randomString += charSet.substring(randomPoz, randomPoz + 1)
  }
  return randomString
}

function getSignResult(str) {
  let signStr = []

  // eslint-disable-next-line no-unused-vars
  for (let i in str) {
    signStr.push(str[i])
  }
  let hmac = crypto.createHmac('md5', 'abf4778f4e6e2a31e')
  // 往hmac对象中添加摘要内容
  const up = hmac.update(signStr.join('|'))

  // 使用 digest 方法输出摘要内容

  return up.digest('hex')
}
export const getLocalTimestamp = () => {
  // 目标时区，东8区
  let targetTimezone = -8
  let _dif = new Date().getTimezoneOffset()
  return new Date().getTime() + _dif * 60 - (targetTimezone * 60 * 60)
}
export const getHeader = (NONCE, TIMESTAMP) => {
  const str = {
    APP_ID: 'dc2d71dbb62244f',
    NONCE: NONCE,
    TIMESTAMP: TIMESTAMP,
    SIGN_TYPE: 'nvwa'
  }
  return {
    APP_ID: str.APP_ID,
    NONCE: str.NONCE,
    TIMESTAMP: str.TIMESTAMP,
    SIGN_TYPE: str.SIGN_TYPE,
    SIGN: getSignResult(str)
  }
}

// 倒计时计算
export const getTimeInterval = (records, sysdate) => {
  let nowDate = sysdate
  for (let i = 0; i < records.length; i++) {
    // const nowDate = this.systemTime
    records[i]['systemTime'] = nowDate
    let openTime = records[i].buyTime
    if (!openTime || new Date(openTime).getTime() < nowDate * 1000) {
      let recordItem = Object.assign({}, records[i])
      recordItem['buyTime'] = ''
      records[i] = recordItem
      continue
    }
    const openTimestamp = Math.floor(new Date(openTime).getTime() / 1000)

    records[i]['timeD'] = Math.floor((openTimestamp - nowDate) / 24 / 3600)
    records[i]['timeH'] = Math.floor((openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600) / 3600)
    records[i]['timeM'] = Math.floor((openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600 - records[i]['timeH'] * 3600) / 60)
    records[i]['timeS'] = Math.floor(
      openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600 - records[i]['timeH'] * 3600 - records[i]['timeM'] * 60
    )
    if (nowDate) {
      let recordItem = Object.assign({}, records[i])
      recordItem['timeGet'] = true
      records[i] = recordItem
    }

    // console.log(this.records)
  }
  // console.log(records)
  return records
}
export const getTimeIntervalCompose = (records, sysdate) => {
  let nowDate = sysdate
  for (let i = 0; i < records.length; i++) {
    // const nowDate = this.systemTime
    records[i]['systemTime'] = nowDate
    let openTime = records[i].startTime
    if (!openTime || new Date(openTime).getTime() < nowDate * 1000) {
      let recordItem = Object.assign({}, records[i])
      // recordItem['startTime'] = ''
      recordItem['buyTime'] = false
      records[i] = recordItem
      continue
    }
    const openTimestamp = Math.floor(new Date(openTime).getTime() / 1000)

    records[i]['timeD'] = Math.floor((openTimestamp - nowDate) / 24 / 3600)
    records[i]['timeH'] = Math.floor((openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600) / 3600)
    records[i]['timeM'] = Math.floor((openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600 - records[i]['timeH'] * 3600) / 60)
    records[i]['timeS'] = Math.floor(
      openTimestamp - nowDate - records[i]['timeD'] * 24 * 3600 - records[i]['timeH'] * 3600 - records[i]['timeM'] * 60
    )
    console.log(records[i])
    if (nowDate) {
      let recordItem = Object.assign({}, records[i])
      recordItem['timeGet'] = true
      records[i] = recordItem
    }

    // console.log(this.records)
  }
  // console.log(records)
  return records
}

function handleNum(num) {
  if (typeof (num) !== 'number' && typeof (num) !== 'string') {
    return 0
  } else {
    return num
  }
}

// 科学计算 +
export const computedAdd = (a, b) => {
  return Decimal(handleNum(a)).add(Decimal(handleNum(b))).toNumber()
}
// 科学计算 -
export const computedSub = (a, b) => {
  return Decimal(handleNum(a)).sub(Decimal(handleNum(b))).toNumber()
}
// 科学计算 X
export const computedMul = (a, b) => {
  return Decimal(handleNum(a)).mul(Decimal(handleNum(b))).toNumber()
}
// 科学计算 /
export const computedDiv = (a, b) => {
  return Decimal(handleNum(a)).div(Decimal(handleNum(b))).toNumber()
}

export const geTel = (tel) => {
  var reg = /^(\d{3})\d{4}(\d{4})$/
  return tel.replace(reg, '$1****$2')
}


// WEBPACK FOOTER //
// ./src/assets/js/globle.js